






























































































import {Inject} from '@cds/common';
import {Component, Vue} from 'vue-property-decorator';
import {BonusService} from '@/services/bonus-service';
import bonuseUpload from './compoennts/bonuseUpload.vue';

@Component({
  components: {
    bonuseUpload
  }
})
export default class wechatImageText extends Vue {
  //新增编辑表单
  public form: any = {
    mainTitle: '',
    mainAdvertisementContent: '',
    mainSubTitle: '',
    franchise: ''
  };
  //查询表单
  public searchForm: any = {
    franchise: '',
    showType: '2',
    awardsAdminIds: ''
  };
  public detailList: any[] = [];

  public formInfo: any = {};
  public labelPosition: String = 'top';
  private tableData: any[] = [];
  public loading: Boolean = false;
  public multipleSelection: any[] = []
  public awardsAdminIdList: any [] = []
  private fromRoute: string = '';
  private hasFetchedList = false;
  private hasFetchedDetail = false;
  private deleteIds: number[] = [];
  @Inject(BonusService) private bonusService!: BonusService;


  public handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  public async created(): Promise<void> {
    this.fromRoute = localStorage.getItem('previousRouteChanged');
    await this.fetchDetail();
    await this.getAwardsAdminIdList();
  }

  //获取列表数据，初次由接口获取，后续由缓存获取
  public async fetchList() {
    this.loading = true;

    if (this.hasFetchedList) {
      // 如果已经获取过数据，则直接从localStorage读取
      const cachedData = JSON.parse(localStorage.getItem('detailsContentList'));

      if (cachedData) {
        this.tableData = cachedData;
        this.loading = false;
        return;
      }
    }

    let res: any = {};
    if (this.fromRoute === '/addDetailsContent') {
      res = await JSON.parse(localStorage.getItem('detailsContentList'));
    } else {
      res = await this.bonusService.awardsContentDetailList(this.searchForm);
      localStorage.setItem('detailsContentList', JSON.stringify(res));
    }

    this.tableData = res || [];
    this.hasFetchedList = true;
    this.loading = false;
  }

  //获取表单数据，初次由接口获取，后续由缓存获取
  public async fetchDetail() {
    this.loading = true;

    if (this.hasFetchedDetail) {
      // 如果已经获取过数据，则直接从localStorage读取
      const cachedData = JSON.parse(localStorage.getItem('detailsContentForm'));
      if (cachedData) {
        this.form = cachedData;
        this.searchForm.franchise = cachedData.franchise;
        this.loading = false;
        return;
      }
    }

    let res: any;
    if (this.fromRoute === '/addDetailsContent') {
      res = await JSON.parse(localStorage.getItem('detailsContentForm'));
      this.deleteIds = JSON.parse(localStorage.getItem('deleteIds')) || [];
    } else {
      res = await this.bonusService.awardsContentDetail({id: this.$route.query.id});
      localStorage.setItem('detailsContentForm', JSON.stringify(res));
    }

    this.form = res;
    this.searchForm.franchise = res.franchise;
    await this.fetchList();
    this.hasFetchedDetail = true;
    this.loading = false;
  }

  //根据类型和franchise改变关联项目
  public async getAwardsAdminIdList() {
    this.searchForm.awardsAdminIds = '';
    const param = {
      franchise: this.searchForm.franchise,
      showType: this.searchForm.showType
    };
    const res = await this.bonusService.awardsOptions(param);
    this.awardsAdminIdList = res || [];
  }

  //缓存表单和列表数据
  public saveLocalStorage(val: any) {
    localStorage.setItem('detailsContentForm', JSON.stringify(this.form));
    localStorage.setItem('detailsContentList', JSON.stringify(this.tableData));
    localStorage.setItem('addDetailsContent', JSON.stringify(val));
  }

  //新增
  public handAdd() {
    this.saveLocalStorage('-1');
    this.$router.push({
      path: '/addDetailsContent',
      query: {franchise: this.form.franchise}
    });
  }

  //修改
  public async handUpdate(row: any) {
    this.saveLocalStorage(row);
    this.$router.push({
      path: '/addDetailsContent',
      query: {franchise: this.form.franchise}
    });
  }

  //添加删除id
  public setDeleteIds(list: any) {
    const deleteItem = list
      .map(item => String(item.id).length !== 13 ? item.id : null)
      .filter(id => id !== null);
    this.deleteIds = [...this.deleteIds, ...deleteItem];
    localStorage.setItem('deleteIds', JSON.stringify(this.deleteIds));
  }

  //删除函数
  private async handleDeleteCommon(rows: any[]): Promise<void> {
    if (!rows.length) {
      this.$message.warning('请选择要删除的数据');
      return;
    }
    try {
      await this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      let list = await JSON.parse(localStorage.getItem('detailsContentList')) || [];
      list = list.filter(item => !rows.some(row => item.id === row.id));
      localStorage.setItem('detailsContentList', JSON.stringify(list));
      this.setDeleteIds(rows);
      await this.fetchList();
      this.$message({
        message: '删除成功',
        type: 'success'
      });
    } catch (e) {
      this.$message({
        type: 'info',
        message: '已取消删除'
      });
    }
  }

  //批量删除
  public async handMinus() {
    await this.handleDeleteCommon(this.multipleSelection);
  }

  //单个删除
  private async handDelete(row: any): Promise<void> {
    await this.handleDeleteCommon([row]);
  }

  //查询
  public async search() {
    const res = await this.bonusService.awardsContentDetailList(this.searchForm);
    this.deleteIds = [];
    this.tableData = res;
    localStorage.setItem('detailsContentList', JSON.stringify(res));
  }

  //保存
  public submitForm(): void {
    const addRef = (this.$refs.form as any)
    addRef.validate(async (valid: any) => {
      const param = {
        ...this.form, deleteIds: this.deleteIds, details: this.tableData.map(item => {
          if (String(item.id).length === 13) {
            return {
              awardsAdminId: item.awardsAdminId,
              content: item.content,
              orderBy: item.orderBy,
              showType: item.showType,
              title: item.title,
            }
          } else {
            return item;
          }
        })
      };
      if (valid) {
        const res = await this.bonusService.awardsContentDetailUpdate(param);
        if (res) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.$router.push('/awardContent');
        }
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  // 重置
  public reset() {
    this.searchForm = {
      ...this.searchForm, ...{
        size: 10,
        current: 1,
        total: 0,
        awardsAdminIds: '',
        showType: '2'
      }
    };
    this.search()
  }

  //取消
  public async cancel() {
    await this.$confirm('当前信息将会丢失，确认是否取消?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    this.$router.push('/awardContent');
  }

  public async statusChange(row: any): Promise<void> {
    let param = {
      id: row.id,
      status: row.status,
      awardsAdminId: row.awardsAdminId
    };
    try {
      await this.$confirm('是否确定修改状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const res = await this.bonusService.awardsContentStatusChange(param);
      if (res) {
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        let list = await JSON.parse(localStorage.getItem('detailsContentList')) || [];
        let item = list.find(item => item.id == row.id);
        if (item) {
          item.status = row.status;
        }
        localStorage.setItem('detailsContentList', JSON.stringify(list));
      } else {
        row.status = row.status == 1 ? 0 : 1;
      }
    } catch (e) {
      this.$message({
        type: 'info',
        message: '已取消修改'
      });
      row.status = row.status == 1 ? 0 : 1;
    }
  }
}
